// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3RsJd","col":"styles_col__26vbe"};